import { FormArray, FormGroup } from '@angular/forms';

// export const crmValidateForm = (
//   form: FormGroup,
//   updateOptions?: {
//     onlySelf?: boolean;
//     emitEvent?: boolean;
//   }
// ): void => {
//   Object.values(form.controls).forEach((control) => {
//     if (control instanceof FormGroup) {
//       crmValidateForm(control, updateOptions);
//     } else if (control instanceof FormArray) {
//       control.controls.forEach((arrayControl) => {
//         if (arrayControl instanceof FormGroup) {
//           crmValidateForm(arrayControl, updateOptions);
//         } else {
//           arrayControl.markAsDirty(updateOptions);
//           arrayControl.updateValueAndValidity(updateOptions);
//         }
//       });
//     } else {
//       control.markAsDirty(updateOptions);
//       control.updateValueAndValidity(updateOptions);
//     }
//   });
// };

export const crmValidateForm = (
  form: FormGroup,
  updateOptions?: {
    onlySelf?: boolean;
    emitEvent?: boolean;
  },
  markAsDirty = true
): void => {
  Object.values(form.controls).forEach((control) => {
    if (control instanceof FormGroup) {
      crmValidateForm(control, updateOptions);
    } else if (control instanceof FormArray) {
      control.controls.forEach((arrayControl) => {
        if (arrayControl instanceof FormGroup) {
          crmValidateForm(arrayControl, updateOptions);
        } else {
          if (markAsDirty) {
            arrayControl.markAsDirty();
          }
          arrayControl.updateValueAndValidity(updateOptions);
        }
      });
    } else {
      if (markAsDirty) {
        control.markAsDirty();
      }
      control.updateValueAndValidity(updateOptions);
    }
  });
};
